export const yunoKey = {
  publicApiKey:
  'prod_gAAAAABkwZmXWxFoVyKr9eAPCAR_nDQg_hEV3jLwhayYarx7vFZpPdoywsizVsePVuUyP4gD5eIXHQUFQ_5CCuglbVDUnFBc9T6Dv5D2i37eqKDMey1xginu2diOFh9TmBcajKope4zN-pa44GHGSwTvR6l7V3UGOu6Xqu4WP4ykuIRjHHzZjuc='
};
